const GO_TEST_NAMES = {
  widget_filter: "widget_filter",
  calendar_reposition: "calendar_reposition",
  searchclips: "searchclips",
  syb_home_promo: "syb_home_promo",
  syb_promo: "syb_promo",
  filters: "filters",
  calendar_widget_button: "calendar_widget_button",
  newtab: "newtab",
  contentfulOn: "contentfulOn",
  search_grid: "search_grid",
  testOneOfferId: "testOneOfferId",
  content: "content",
};

export { GO_TEST_NAMES };
